import { HttpContextToken } from '@angular/common/http';

/**
 * Marca POR PETICIÓN: tope de tiempo, en milisegundos, de CADA INTENTO contra el
 * servidor. La aplica `RequestTimeoutInterceptor`, el interceptor más cercano al
 * backend, así que el original y el reintento que hace `auth.interceptor.ts` tras
 * renovar la sesión cuentan cada uno el suyo, y la espera del diálogo de sesión
 * (que vive más arriba en la cadena) NO cuenta.
 *
 * ⚠️ Por qué no un `timeout()` en el data source: aplicado por encima de la cadena
 * de interceptores, vence mientras el diálogo de sesión espera al operador,
 * desuscribe su `afterClosed()` y deja `isRefreshing` en `true` para siempre — todo
 * 401 posterior de la app se queda esperando un refresh que nunca llega.
 *
 * Default `null` = sin tope. Solo un número finito > 0 aplica.
 */
export const REQUEST_ATTEMPT_TIMEOUT_MS = new HttpContextToken<number | null>(() => null);
